/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/artikel-verfuegbarkeit-inline-info/shop.artikel-verfuegbarkeit-inline-info.component.ts.
 */
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ArtikelVerfuegbarkeit} from '../../../../models/artikel-verfuegbarkeit';

/**
 * Zweck: Beschreibt class ShopArtikelVerfuegbarkeitInlineInfoComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'shop-artikel-verfuegbarkeit-inline-info',
    templateUrl: 'shop.artikel-verfuegbarkeit-inline-info.component.html',
    styleUrls: ['shop.artikel-verfuegbarkeit-inline-info.component.scss'],
    standalone: false
})
export class ShopArtikelVerfuegbarkeitInlineInfoComponent implements OnInit, OnChanges {
  @Input() data: ArtikelVerfuegbarkeit;

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit() {
    this.render();
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }



/**
 * Beschreibt Methode render und ihren Rückgabevertrag.
 */
  render() {
    const lieferung = false;
    if (this.data.Verfuegbarkeitsinformation) {
      this.data.Verfuegbarkeitsinformation.forEach(vi => {
        if (vi.LieferungMoeglich) {
          if (vi.InfoText == 'Teilmenge lagernd') {
            vi.color = 'orange2';
          } else {
            vi.color = 'green';
          }

        } else if (vi.InfoCode == 'BS') {
          vi.color = 'orange';

        } else {
          vi.color = 'red';
        }
      });
    }
  }
}
